@if (isSmallScreen$ | async) {
  <ss-www-large-item-cards
    [largeItemCardsData]="nowPayingAsLargeItemCards"
    [lastBlock]="false"
  ></ss-www-large-item-cards>
} @else {
  <div class="md:px-20 lg:px-28 xl:px-32 pt-20">
    @if (nowPlayingData.title) {
      <h2
        class="text-center"
        [ssDirectus]="{
          collection: 'nowPlaying',
          item: nowPlayingData.id,
          fields: ['title'],
        }"
      >
        {{ nowPlayingData.title }}
      </h2>
    }
    <ss-www-image-with-loader
      class="w-full aspect-[4/3] mt-6"
      [fileDetail]="nowPlayingData.image"
      desktopImageSize="2/3rds"
    >
      <div
        class="absolute top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-end md:gap-1 md:p-1 lg:p-4 lg:gap-4 xl:p-8"
      >
        @if (nowPlayingData.subtitle) {
          <h4
            [ssDirectus]="{
              collection: 'nowPlaying',
              item: nowPlayingData.id,
              fields: ['subtitle'],
            }"
          >
            {{ nowPlayingData.subtitle }}
          </h4>
        }
        @if (nowPlayingData.buttons.length) {
          <div class="flex gap-5">
            @for (
              button of nowPlayingData.buttons;
              track trackButtons($index, button)
            ) {
              <ss-building-block-button-link
                [buttonLink]="button.item"
              ></ss-building-block-button-link>
            }
          </div>
        }
      </div>
    </ss-www-image-with-loader>
  </div>
}
